export default "__VITE_ASSET__DZEkXsht__"